import getExtensibilityState from '../store/getExtensibilityState';
import TaskPaneRunningInstance from '../store/schema/TaskPaneRunningInstance';
import TaskPaneType from '../store/schema/TaskPaneType';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'terminatePersistantTaskPaneAddinWithAppId',
    function terminatePersistantTaskPaneAddinWithAppId(addinId: string) {
        const persistentTaskpane: TaskPaneRunningInstance = getExtensibilityState().taskPanes.get(
            TaskPaneType.Persistent
        );
        if (persistentTaskpane && persistentTaskpane.addinCommand.extension.Id === addinId) {
            getExtensibilityState().taskPanes.delete(TaskPaneType.Persistent);
        }
    }
);
